import { useEffect, useState } from "react";
import tabsActions from "../../../Actions/TabsActions";
import tabsStore from "../../../Stores/TabsStore";
import tabsConstants from "./../../../Constants/TabsConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "./../../../Context/LanguageContext";
import OrderDetails from "./orderComponent/orderDetails";
export default function OrderHistroy(props) {
  const { isorderHistroy, handleClosePopOver, equipmentID } = props;
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [statusList, setStatusList] = useState([]);
  const [selStatus, setSelStatus] = useState("");
  const [dropDown, setDropDown] = useState(50);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (selStatus !== "") {
      setGlobalSpinner(true);
      tabsActions.getAuftragDetails(equipmentID, selStatus, parseInt(dropDown));
    }
  }, [dropDown, selStatus]);

  useEffect(() => {
    if (isorderHistroy) {
      setGlobalSpinner(true);
      tabsActions.getAuftragStatus();
    }
  }, [isorderHistroy]);

  useEffect(() => {
    function getOrderStatusSuccess() {
      const res = tabsStore.getOrderStatusResult();
      if (res.length > 0) {
        setStatusList(res);
        setSelStatus(res[2].id);
      } else {
        setStatusList([]);
      }

      setGlobalSpinner(false);
    }
    function getOrderStatusFailure() {
      setGlobalSpinner(false);
    }
    tabsStore.addChangeListener(
      tabsConstants.GET_ORDER_STATUS_SUCCESS,
      getOrderStatusSuccess,
    );
    tabsStore.addChangeListener(
      tabsConstants.GET_ORDER_STATUS_FAILURE,
      getOrderStatusFailure,
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_ORDER_STATUS_SUCCESS,
        getOrderStatusSuccess,
      );
      tabsStore.removeChangeListener(
        tabsConstants.GET_ORDER_STATUS_FAILURE,
        getOrderStatusFailure,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      var _details = tabsStore.getResult();

      setData(_details);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAIL_SUCCESS,
      updateData,
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAIL_SUCCESS,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      var _details = tabsStore.getResult();
      setData(null);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAIL_FAILURE,
      updateData,
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAIL_FAILURE,
        updateData,
      );
    };
  }, []);

  return (
    <div
      className="modal in dialogBox "
      id="MsgModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="MsgModalCenterTitle"
    >
      <div className="custom-modal modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="orderHistroyheader">
              {localization.OrderhistoryTitle}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="orderHistroyheaderModalClose"
              onClick={handleClosePopOver}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <div className="row mb-5 ">
              <div className="col-3 d-flex">
                <div>
                  <label htmlFor="Status">{localization.orderStatus}</label>
                </div>

                <div className="ml-3 ">
                  <select
                    className="form-control"
                    id="Status"
                    name="Status"
                    required
                    value={selStatus}
                    onChange={(e) => {
                      setSelStatus(e.target.value);
                      setData(null);
                    }}
                  >
                    {statusList.map((item, i) => {
                      return (
                        <option value={item.id} key={i}>
                          {item.text}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col d-flex">
                <div>
                  <label htmlFor="dataRange">
                    {localization.selectNumberOfRecordToView}
                  </label>
                </div>

                <div className="ml-3 ">
                  <select
                    className="form-control"
                    id="dataRange"
                    name="dataRange"
                    required
                    value={dropDown}
                    onChange={(e) => {
                      setDropDown(e.target.value);
                      setData(null);
                    }}
                  >
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={150}>150</option>
                    <option value={200}>200</option>
                    <option value={250}>250</option>
                  </select>
                </div>
              </div>
            </div>
            {data && (
              <div className="table-responsive">
                <OrderDetails items={data} />
              </div>
            )}
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
}
